<template>
  <vue-record-audio
    mode="press"
    @result="onResult"
  />
</template>

<script>
import Vue from 'vue'
import VueRecord from '@codekraft-studio/vue-record'

try {
  Vue.use(VueRecord)
} catch (e) {
  console.warn('Audio recorder init error:', e)
}

export default {
  name: 'AudioRecorder',
  methods: {
    onResult(data) {
      const file = new File([data], `${this.$moment().format('jYYYY/jM/jD_HH:MM')}.mp3`, {
        type: 'audio/mpeg',
      })
      const preview = URL.createObjectURL(file)
      this.$emit('preview', preview)
      this.$emit('file', file)
    },
  },
}
</script>

<style scoped>

</style>
